import {ImageRequestParams} from "../models/image/image-request-params";

export class RemoveUserImageRequestParams extends ImageRequestParams {
  constructor(width: Number, height: Number) {
    super({width, height});

    this._resourceName = `bolao26/Icons/Remove_User_Icon`;
  }
}
